module.exports = __webpack_public_path__ + "static/media/quienes_somos_new3.07ba4417.jpg";